import {put, call} from 'redux-saga/effects';
import {getWorkflowHistory} from '@pluto/rest';
import {setNotificationAction} from '@pluto/notification';
import {setContentItemWorkHistoryAction} from '../../ContentItemViewWorkHistoryActions';
import {WorkHistoryParams} from '../../../ContentItemViewWorkHistoryTypes';

interface Props {
    type: string;
    payload: {
        id: number;
        params: WorkHistoryParams;
    };
}

export function* workHistory({payload}: Props) {
    const {id, params} = payload;

    try {
        const response = yield call(getWorkflowHistory, id, params);
        yield put(setContentItemWorkHistoryAction(response));
    } catch (error) {
        yield put(
            setNotificationAction({
                type: 'error',
                text: error.message,
            })
        );
    }
}
